import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InboundEmailsRoutingModule } from './inbound-emails-routing.module';
import { InboundEmailsComponent } from './inbound-emails.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomExcelMapperModule } from 'src/app/shared/custom-excel-mapper/custom-excel-mapper.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    InboundEmailsComponent
  ],
  imports: [
    CommonModule,
    InboundEmailsRoutingModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatDatepickerModule,
    CustomExcelMapperModule,
    MatFormFieldModule,
    MatAutocompleteModule

  ],
  exports:[InboundEmailsComponent]
})
export class InboundEmailsModule { }
